<script setup>
import TextInput from '@/components/TextInput.vue';
import { onMounted, watch, ref } from 'vue';

defineProps({
    canResetPassword: {
        type: Boolean,
    },
    status: {
        type: String,
    },
});

const form = ref({
    phone: '',
});
const isCheck = ref(false);
const showPassword = ref(false);
const showConfirmPassword = ref(false);
const errors = ref({});

</script>

<template>
    <div class="w-full grid grid-rows-[56px_1fr] bg-white h-full">
        <router-link :to="{name: 'login'}" class="w-full flex justify-start items-center px-4">
            <svg class="fill-gray-800 w-6 h-6" xmlns="http://www.w3.org/2000/svg"
                xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" id="Layer_1" x="0px" y="0px"
                viewBox="0 0 492 492" style="enable-background:new 0 0 492 492;" xml:space="preserve">
                <g>
                    <g>
                        <path
                            d="M198.608,246.104L382.664,62.04c5.068-5.056,7.856-11.816,7.856-19.024c0-7.212-2.788-13.968-7.856-19.032l-16.128-16.12    C361.476,2.792,354.712,0,347.504,0s-13.964,2.792-19.028,7.864L109.328,227.008c-5.084,5.08-7.868,11.868-7.848,19.084    c-0.02,7.248,2.76,14.028,7.848,19.112l218.944,218.932c5.064,5.072,11.82,7.864,19.032,7.864c7.208,0,13.964-2.792,19.032-7.864    l16.124-16.12c10.492-10.492,10.492-27.572,0-38.06L198.608,246.104z" />
                    </g>
                </g>
            </svg>
        </router-link>
        <div class="w-full h-[calc(100dvh_-_56px)] px-8 py-4 flex flex-col transform_scale">
            <div>
                <img src="@/assets/images/Forgot_password_resized.png" alt="Forgot_password_resized.png">
            </div>
            <h1 class="text-3xl font-bold text-gray-800 dark:text-white transform_transition">
                Quên mật khẩu?
            </h1>
            <p class="mt-2 transform_transition">
                Vui lòng nhập số điện thoại của bạn để lấy mã OTP tiến hành đặt lại mật khẩu.
            </p>
            <div class="divide-y divide-gray-200">
                <div class="py-8 text-base leading-6 space-y-4 text-gray-700 sm:text-lg sm:leading-7">
                    <div class="relative transform_transition">
                        <label for="phone" class="block font-medium text-sm text-gray-700">
                            <span> Số điện thoại </span>
                            <span class="text-red-500">(*)</span>
                        </label>

                        <TextInput id="phone" type="tel" inputmode="numeric" pattern="[0-9]*" class="mt-1 block w-full"
                            v-model="form.phone" autocomplete="phone" />

                            <p v-if="errors && errors.phone" class="text-sm text-red-600 mt-2">
                                {{ errors.phone[0] }}
                            </p>
                    </div>
                    <div class="relative w-full text-center transform_transition">
                        <button type="submit" class="w-full py-3 text-xl bg-green-600 text-white rounded-md "
                            :class="{ 'cursor-pointer': isCheck, 'opacity-25 cursor-not-allowed': !isCheck }"
                            :disabled="!isCheck">
                            Lấy mã OTP
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<style scoped>
.transform_transition {
    animation: transform 1s ease-out;
}

@keyframes transform {
    0% {
        transform: translateY(-100%);
        opacity: 0;
    }

    100% {
        transform: translateY(0);
        opacity: 1;
    }
}
.transform_scale {
    animation: scale 1s ease-out;
}

@keyframes scale {
    0% {
        transform: scale(0.99);
        opacity: 0;
    }
    50% {
        transform: scale(1.01);
        opacity: 1;
    }

    100% {
        transform: scale(1);
        opacity: 1;
    }
}
</style>
